import Vue from 'vue';
import { setStaticSourceUrl } from '@/util';

Vue.directive('texture', function(el, binding) {
  const value = binding.value || '';
  el.src = setStaticSourceUrl(value);
});
